import { render, staticRenderFns } from "./PageTrip.vue?vue&type=template&id=0558e24e&scoped=true&"
import script from "./PageTrip.vue?vue&type=script&lang=js&"
export * from "./PageTrip.vue?vue&type=script&lang=js&"
import style0 from "./PageTrip.vue?vue&type=style&index=0&id=0558e24e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0558e24e",
  null
  
)

export default component.exports